import { api } from "@services/api";
import type { PldaGridResponse } from "@services/plda/types";

export const getPldaData = async (imoNumber: number | string): Promise<PldaGridResponse> =>
  api.get<PldaGridResponse>("bff-vessel", "vessels/plda/search", {
    params: { imoNumber },
  });
